import { CanAccess } from "ra-core";
import { DataTable } from "@/components/admin/data-table";
import { EditButton } from "@/components/admin/edit-button";
import { List } from "@/components/admin/list";

import { AuthorizationToSellStatusPill } from "./AuthorizationToSellStatusPill";

/**
 * ASSUMPTION: no create action here — the 4 developers are seeded (TASK-001)
 * and a new developer only makes sense alongside a new project, whose codes
 * are themselves constrained to 6 known values (see projects/ProjectList.tsx).
 */
export function DeveloperList() {
  return (
    <List sort={{ field: "legal_name", order: "ASC" }} perPage={25}>
      {/* rowClick always opens the read-only show page (TASK-031), for every
          role; the Editar column below stays direccion-only. */}
      <DataTable rowClick="show">
        <DataTable.Col source="legal_name" />
        <DataTable.Col source="authorization_to_sell_status">
          <AuthorizationToSellStatusPill />
        </DataTable.Col>
        <DataTable.Col label={false}>
          <CanAccess resource="developers" action="edit">
            <EditButton />
          </CanAccess>
        </DataTable.Col>
      </DataTable>
    </List>
  );
}
